/** @format */

import Base from '@/modules/auth/Base.vue'
import Deals from '@/modules/agent/Deals'
import Calculator from '@/modules/shared/calculator/Calculator'
import { ifRoleAuthenticated } from '@/router/navigationGuards'

const routes = [
  {
    path: '/agent',
    component: Base,
    beforeEnter: (to, from, next) => {
      ifRoleAuthenticated(to, from, next, 'ROLE_AGENT')
    },
    children: [
      {
        path: 'deals',
        component: Deals,
        name: 'agent.list-deals',
        meta: { layout: "agent" },
      },
      {
        path: 'calculator',
        component: Calculator,
        name: 'agent.calculator',
        meta: { layout: "agent" },
      }
    ]
  }
]

export default routes
